import { type DocumentType, graphql } from '@generated/gql';

export const EDIT_ACCOUNT_ALLOCATIONS_FETCH_PORTFOLIO_REPORTS = graphql(
  /** GraphQL */ `
  query editAccountAllocationsFetchPortfolioReports($input: FetchPortfolioReportsInput!) {
    fetchPortfolioReports(input: $input) {
      portfolioReports {
        id
        expectedCashPercentage
        holdings {
          expectedPercentage
          isCashEquivalent
          customExpectedPercentage
          financialProduct {
            id
            ticker
            translatedName {
              en
              fr
              es
            }
            isCash
          }
        }
        subAccounts {
          id
          marketValueCents
          subAccount {
            id
            state
            account {
              id
              custodianAccountNumber
              user {
                firstName
                entityName
              }
            }
          }
          holdings {
            expectedPercentage
            isCashEquivalent
            customExpectedPercentage
            financialProduct {
              id
              ticker
              translatedName {
                en
                fr
                es
              }
              isCash
            }
          }
        }
      }
    }
  }
`,
);

export type EditAccountAllocationsPortfolioReport = DocumentType<
  typeof EDIT_ACCOUNT_ALLOCATIONS_FETCH_PORTFOLIO_REPORTS
>['fetchPortfolioReports']['portfolioReports'][number];
